<section class="py-4">

  <div class="row mx-2">

    <div class="col-12 col-sm-12 pb-2 px-3">
      <app-date-interval [(inicio)]="params.filter.dataInicio" [(fim)]="params.filter.dataFim"
        (fimChange)="updateResult()" (inicioChange)="updateResult()"></app-date-interval>
    </div>

  </div>

  <div *ngIf="tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div *ngIf="tableLoading" class="p-5 d-flex justify-content-center position-relative">
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>

  <div *ngIf="!tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.id"
              (tableOrderChange)="changeOrder()">ID</th>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.nome"
              (tableOrderChange)="changeOrder()">Nome</th>
            <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.dataCriacao"
              (tableOrderChange)="changeOrder()">Criação</th>
            <th class="text-center py-2">
              <span data-toggle="tooltip" data-placement="bottom" title="Consulta em lote">
                <a [routerLink]="['/consulta/lote','realizar']" class="btn btn-sm btn-success btn-icon">
                  <i class="mdi mdi-plus"></i>
                  <span>Consulta em lote</span>
                </a>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="listaResultado.length==0">
            <td class="text-center py-5 text-secondary w-500" colspan="8">
              Sem registros
            </td>
          </tr>
          <tr *ngFor="let r of listaResultado">
            <td>{{r.id}}</td>
            <td>{{r.dataCriacao}}</td>
            <td>{{r.nome}}</td>
            <td class="py-1">
              <div class="d-flex align-items-center justify-content-end">
                <span data-toggle="tooltip" data-placement="bottom" title="Visualizar resultado da consulta de lote">
                  <a [routerLink]="['/consulta','lote','resultado', r.id]" class="btn btn-sm btn-info btn-icon">
                    <i class="mdi mdi-eye"></i>
                  </a>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer bg-white row justify-content-between">
      <div class="pb-2 pb-sm-0">
        <ngb-pagination [pageSize]="params.per_page" [boundaryLinks]="true" [collectionSize]="total"
          [(page)]="params.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
        </ngb-pagination>
      </div>
      <div class="pb-2 pb-sm-0">
        <div class="btn-group" role="group">
          <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  params.per_page==10}"
            type="button" class="btn btn-outline-primary">10</button>
          <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  params.per_page==25}"
            type="button" class="btn btn-outline-primary">25</button>
          <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  params.per_page==50}"
            type="button" class="btn btn-outline-primary">50</button>
          <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': params.per_page==100}"
            type="button" class="btn btn-outline-primary">100</button>
        </div>
      </div>
    </div>
  </div>

</section>